function loadCriterioPor() {
    var critPor = ($.query.get('formatoproducto').toLowerCase() !== '') ? $.query.get('formatoproducto').toLowerCase() : 'TODOS';
    console.log(critPor);
    var selectValue = 'TODOS';
    switch (critPor) {
        case 'cd':
            selectValue = 'CDs';
            break;
        case 'vinilo':
            selectValue = 'VINILOS';
            break;
        case 'libro':
            selectValue = 'LIBROS';
            break;

    }
    $('select#buscarpor').val(selectValue);


    $(".buscador").find("button.dropdown-toggle").html(selectValue);
}

function loadCriterioOrden() {
    var critPor = ($.query.get('orden').toLowerCase() != '') ? $.query.get('orden').toLowerCase() : 're';
    var selectValue = 'rel';
    switch (critPor) {
        case 're':
            selectValue = 'rel';
            break;
        case 'fecha':
            selectValue = 'fecha';
            break;
        case 'tentregaasc':
            selectValue = 'disp';
            break;
        case 'minprec':
            selectValue = 'minprec';
            break;
        case 'maxprec':
            selectValue = 'maxprec';
            break;
    }
    //$('select#ordenar').val(selectValue);
}


loadCriterioPor();
loadCriterioOrden();